import { useEffect, useState } from "react";
import { Category, Chapter } from "../types/category";

const useVocab = (chapterIds?: string[]) => {
	const [categories, setCategories] = useState<Category[]>([]);
	const [loading, setLoading] = useState(true);

	useEffect(() => {
		const fetchData = async () => {
			const response = await fetch(process.env.PUBLIC_URL + "/N5vocab.json");
			const data = await response.json();

			if (chapterIds) {
				// Filter categories based on selected chapterIds
				let selectedCategories: Category[] = [];

				data.forEach((category: Category) => {
					const filteredChapters: Chapter[] = category.chapters.filter((chapter) => chapterIds.includes(chapter.id));
					if (filteredChapters.length > 0) {
						selectedCategories.push({ ...category, chapters: filteredChapters });
					}
				});
				setCategories(selectedCategories);
				setLoading(false);
				return;
			}
			setCategories(data);
			setLoading(false);
		};

		fetchData();
	}, []);

	return { categories, loading };
};

export default useVocab;
